import './App.css';
import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import LandingPage from './Pages/LandingPage';
import About from './Pages/About';
import app from './firebase'; // ← test import (ensure src/firebase.js exists)
import Party from './Pages/Party';

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/birthday",
    element: <Party />,
  },
]);

function App() {
    useEffect(() => {
    if (app && app.name) {
      console.log('✅ Firebase initialized:', app.name, 'projectId:', app?.options?.projectId ?? '(unknown)');
    } else {
      console.warn('⚠️ Firebase does not appear to be initialized. Check src/firebase.js and your .env variables.');
    }
  }, []);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
